module.exports = __webpack_public_path__ + "img/202412_bnr900_900_3.7ccd73d.png";